import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import RuleGroupForm from "./RuleGroupForm";
import { IRuleGroup } from "../../../model/evaluation/RuleGroup";
import {IRuleGroupElementPresentationModel } from "../../../presenter/evaluation/RuleGroupsPresenter";
import RuleGroupPresentationModel from "../../../presenter/evaluation/model/RuleGroupPresentationModel";

export interface State {
  selectedBusinessRuleIds?: string[];
  setSelectedBusinessRuleIds?: any;
  setElements?: any;
  elements: IRuleGroupElementPresentationModel[];
}

export interface UpdateRuleGroupFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IRuleGroup;
  codebooks: any;
}

class UpdateRuleGroupForm extends React.Component<
  UpdateRuleGroupFormProps,
  State
> {
  constructor(props: UpdateRuleGroupFormProps) {
    super(props);
    this.state = {
      selectedBusinessRuleIds: [],
      elements: [],
      setSelectedBusinessRuleIds: selectedRules => {
        this.setState({ selectedBusinessRuleIds: selectedRules });
      },
      setElements: elements => {
        this.setState({ elements: elements });
      }
    };
  }
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler(e => {
      const { selectedBusinessRuleIds, elements } = this.state;
      e.preventDefault();
      let updatedRecord;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updatedRecord = RuleGroupPresentationModel(values);
          updatedRecord.id = rowData.id;
          updatedRecord.ruleGroupElements = elements;
          updatedRecord.selectedElementsIds = selectedBusinessRuleIds;
        }
      });
      return updatedRecord;
    });
  }

  render() {
    const { translate, rowData, codebooks } = this.props;
    const { setSelectedBusinessRuleIds, setElements } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <RuleGroupForm
        codebooks={codebooks}
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
        setElements={setElements}
        setSelectedBusinessRuleIds={setSelectedBusinessRuleIds}
      />
    );
  }
}

export default UpdateRuleGroupForm;
